<div *ngIf="clientData; else loading"
     class="container-fluid padding-top padding-bottom">
  <div class="row">
    <div class="col-md-12">
      <button class="btn btn-primary"
              color="primary"
              (click)="goBack()">Go Back</button>
    </div>
    <div class="col-md-12 text-center">
      <h1>{{ clientData?.name}}</h1>
    </div>
    <div class="col-md-12 text-center">
      <md-slide-toggle [(ngModel)]="clientData.enableCustomPages"
                       (change)="updateEnableCustomPagesToggle($event)">
        <h4>Allow on Facility Portal</h4>
      </md-slide-toggle>
    </div>
    <div class="col-sm-3">
      <h2>Custom Pages</h2>
    </div>
    <div class="col-md-9"
         style="margin-top:20px;margin-bottom:10px;padding-top:12px;">
      <button class="btn btn-primary"
              style="float: right"
              (click)="newPage()">New Page</button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 sm-padding-top margin-bottom">
      <table *ngIf="pages?.length > 0; else noPages"
             class="table table-hover">
        <thead class="thead-dark">
          <tr>
            <th>Name</th>
            <th>Date Created</th>
            <th>Last Update</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let page of pages">
            <td>{{page?.name}}</td>
            <td>{{page?.createdOn | date:'short'}}</td>
            <td>{{page?.updatedOn | date:'short'}}</td>
            <td style="text-align: right">
              <button class="btn btn-primary"
                      [routerLink]="['./'+page?.$key]">Edit</button>
              <button class="btn btn-danger"
                      (click)="deletePage(page)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>
<ng-template #noPages>
  <h2 class="full-width text-center">There are no saved pages. Try creating a new one.</h2>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/custom-pages/custom-pages.component.html